import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosNotificationsOutline } from "react-icons/io";
import { AiOutlineMenu } from "react-icons/ai";
import CustomButton from "./CustomButton";
import "../assets/css/Header.css";
import "../assets/css/Home.css";

function Header({loggedIn}) {
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(loggedIn );

  const onLogInUser = () => {
    navigate("/login");
  };

  const onNotification = () => {
    navigate("/notification");
  };
  useEffect(()=>{
    setIsLoggedIn(loggedIn)
  },[loggedIn])

  return (
    <>
      <div
        className="bg-black"
        style={{ position: "sticky", top: "0px", zIndex: "1000" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="d-flex justify-content-between align-items-center bg-black text-white p-2"
            >
              {/* Logo and Menu */}
              <div
                className="d-none d-lg-flex justify-content-evenly"
                style={{ width: isLoggedIn ?  "70%"  :'7%'}}
              >
                <Link to="/" className="text-decoration-none">
                  <span className="fs-5 fw-normal menu-item text-white">
                    Home
                  </span>
                </Link>

                {/* Conditionally Render Menu Items */}
                {isLoggedIn && (
                  <>
                    <Link to="/notification" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Notification
                      </span>
                    </Link>
                    <Link to="/games" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Games
                      </span>
                    </Link>
                    <Link to="/" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Messenger
                      </span>
                    </Link>
                    <Link to="/profile" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Profile
                      </span>
                    </Link>
                    <Link to="/" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Stringer
                      </span>
                    </Link>
                    <Link to="/" className="text-decoration-none">
                      <span className="fs-5 fw-normal menu-item text-white">
                        Find Players
                      </span>
                    </Link>
                  </>
                )}
              </div>

              {/* Actions */}
              <div
                className="d-none d-lg-flex justify-content-evenly align-items-center"
                style={{ width: "23%" }}
              >
                <div className="fs-5 fw-normal">Language</div>
                <div>

                  {/* {!isLoggedIn ? (
                    <CustomButton
                      buttonText={"Log In"}
                      className="custom-log-in px"
                      onClick={onLogInUser}
                    />
                  ) : (
                    <CustomButton
                      buttonText={"Log Out"}
                      className="custom-log-in px"
                      onClick={() =>{navigate('/'); setIsLoggedIn(false)}}
                    />
                  )} */}
                  
                </div>
                
                {isLoggedIn && (
                  <div className="bg-black text-end fs-4">
                    <IoIosNotificationsOutline
                      style={{ color: "white", cursor: "pointer" }}
                      onClick={onNotification}
                    />
                  </div>
                )}
              </div>

              {/* Hamburger Menu for Mobile/Tablet */}
              {/* <div className="d-lg-none">
                <AiOutlineMenu
                  className="text-white fs-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                  aria-controls="mobileMenu"
                  style={{ cursor: "pointer" }}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Offcanvas Menu */}
      <div
        className="offcanvas offcanvas-end bg-black text-white"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="mobileMenuLabel">
            Menu
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <Link to="/" className="text-decoration-none text-white d-block mb-3">
            <span className="fs-5 fw-normal menu-item">Home</span>
          </Link>

          {/* Conditionally Render Mobile Menu Items */}
          {isLoggedIn && (
            <>
              <Link
                to="/notification"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Notification</span>
              </Link>
              <Link
                to="/meetfriends"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Games</span>
              </Link>
              <Link
                to="/"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Messenger</span>
              </Link>
              <Link
                to="/"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Profile</span>
              </Link>
              <Link
                to="/"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Stringer</span>
              </Link>
              <Link
                to="/"
                className="text-decoration-none text-white d-block mb-3"
              >
                <span className="fs-5 fw-normal menu-item">Find Players</span>
              </Link>
            </>
          )}
          <hr />
          <div className="mb-3">
            <span className="fs-5 fw-normal">Language</span>
          </div>
          <div className="mb-3">
            {/* {!isLoggedIn ? (
              <CustomButton
                buttonText={"Log In"}
                className="custom-log-in px"
                onClick={onLogInUser}
              />
            ) : (
              <CustomButton
                buttonText={"Log Out"}
                className="custom-log-in px"
                onClick={() => setIsLoggedIn(false)}
              />
            )} */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M16 9a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-2 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/><path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M3 12c0 2.09.713 4.014 1.908 5.542A8.99 8.99 0 0 1 12.065 14a8.98 8.98 0 0 1 7.092 3.458A9 9 0 1 0 3 12m9 9a8.96 8.96 0 0 1-5.672-2.012A6.99 6.99 0 0 1 12.065 16a6.99 6.99 0 0 1 5.689 2.92A8.96 8.96 0 0 1 12 21"/></g></svg>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
